import React, { forwardRef } from 'react';
import HBLabel from '../../HBLabel/HBLabel';
import HBText from '../../HBText/HBText';
import { vars } from '../../../theme';
import { Input, Bar } from './HBInputMaterial.styles';
import { IMaterialProps } from '../../HBTextField/HBTextField.types';
import { HBInputProps } from '../HBInput.types';
import { Fieldset } from '../../HBTextField/HBTextField.styles';
import { MustIncludeOneOfTestIdProps } from '../../common/internal/test-id.types';
import { useBuildTestIdInternal } from '../../../hooks/useBuildTestIdInternal';

type HBInputMaterialProps = HBInputProps &
    IMaterialProps &
    MustIncludeOneOfTestIdProps;

const HBInputMaterial = forwardRef<HTMLInputElement, HBInputMaterialProps>(
    (props, ref) => {
        const {
            label,
            errorMessage,
            size = 'md',
            id,
            name,
            testIdName,
            testId,
            ...baseProps
        } = props;

        const finalTestId = useBuildTestIdInternal({
            testId,
            identifier: testIdName || id || name,
            suffix: 'input-material',
            componentName: 'HBInputMaterial'
        });

        return (
            <Fieldset>
                <Input
                    {...baseProps}
                    className={props.value !== '' && 'not-empty'}
                    size={size}
                    ref={ref}
                    data-testid={finalTestId}
                />
                <Bar error={!!errorMessage || props.error} />
                <HBLabel
                    size={size}
                    text={label}
                    disabled={props.disabled}
                    color={vars.colors.text.secondary}
                    testId={finalTestId ? `${finalTestId}-label` : undefined}
                />
                {errorMessage && (
                    <HBText type="body12" className="helper-text">
                        {errorMessage}
                    </HBText>
                )}
            </Fieldset>
        );
    }
);

export default HBInputMaterial;
